"use client";

import { NextIntlClientProvider } from "next-intl";

import { ErrorPage } from "@/components/error-page";
import enMessages from "@/messages/en.json";

export default function Error({
  error: _error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <NextIntlClientProvider locale="en" messages={enMessages}>
      <ErrorPage />
    </NextIntlClientProvider>
  );
}
